import checkQueryParams, {updateQueryString} from "../../utils/queryParams";

document.addEventListener('DOMContentLoaded', () => {
  const selectEl = document.getElementById('news-post-cat-select');
  const loadBtnEl = document.getElementById('news-post-load-btn');
  const newsListEl = document.getElementById('a-posts-news-list');
  const optionEls = selectEl.querySelectorAll('option');

  selectEl.addEventListener('change', (e) => {
    const selectedId = optionEls[e.target.selectedIndex].value;
    window.location.href = updateQueryString('qp', null, updateQueryString('cat', selectedId));
  });

  loadBtnEl.addEventListener('click', () => {
    const catParam = checkQueryParams('cat');
    const pageParam = checkQueryParams('qp');
    const page = pageParam ? Number(pageParam) : 0;
    loadBtnEl.disabled = true;
    fetch(`/wp-json/aeroseum-blocks/v1/get-paginated-news?page=${page + 1}&cat=${catParam}`)
        .then((res) => res.json())
        .then((res) => {
          let els = ``;
          loadBtnEl.disabled = false;

          if (!res || (res || []).length === 0) {
            loadBtnEl.remove();
            return;
          }

          window.history.replaceState({}, '', updateQueryString('qp', page + 1));

          (res || []).map((item) => {
            els += `
            <div class="col-md-6 col-lg-3">
              <a href="${item.fields.url}" class="a-card">
              <img decoding="async" src="${item.fields.thumbnail}" alt="${item.post_title}" style="object-fit:cover;object-position:center" height="200">
                <p class="a-card__subtitle">${item.fields.date}</p>
                <h3 class="a-card__title">${item.post_title}</h3>
              </a>
            </div>
            `;
          });

          newsListEl.innerHTML = newsListEl.innerHTML + els;
        }).catch(() => {
      loadBtnEl.disabled = false;
    });
  });
});
